import Steps from './Steps.vue'
export default Steps